module.exports = __webpack_public_path__ + "media/img/icon-webapp-f1e1b8a1.png";